
<div
  class="container-fluid d-flex flex-row justify-content-center mb-0 mt-1 pt-3 pt-xl-0 pb-5 pb-xl-3 shadow-lg col-12 col-lg-8"
>
  <div class="jumbotron-fluid mb-5 pb-4 mb-xl-4">
    <div class="head-icon d-flex justify-content-center my-0 pb-0">
      <img
        class="mx-auto mb-1 pb-0"
        src="assets/img/mafuta-logo-2b.svg"
        width="35"
        height="35"
      />
  </div>
    <div class="card-body my-0 py-2 shadow-lg">
    <h3 class="text-info d-flex justify-content-center mt-2 pt-1 mb-3">
      Login
    </h3>
    <form [formGroup]="userForm" (ngSubmit)="login()">

      <div class="form-group text-primary">
        <label for="userPhone1" [ngClass]="fval.userPhone1.valid ? 'text-info' : ''">Phone Number<i  *ngIf="fval.userPhone1.valid" class="material-icons">check_circle</i></label>
         <div class="input-group mb-0">
         <div class="input-group-prepend">
          <div class="input-group-text">
            <i class="fas fa-phone text-primary mx-auto" style="size: 50px">
           </i></div> </div>
                         <input id="userPhone1" formControlName="userPhone1" type="text" class="form-control"  [ngClass]=" { 'is-invalid': (fval.userPhone1.touched||fval.userPhone1.dirty) && fval.userPhone1.errors }" placeholder="e.g. 07XXXXXXXX" autocomplete="off"/>
                       </div>
                     <div class="text-danger col" *ngIf="(fval.userPhone1.touched||fval.userPhone1.dirty)  && fval.userPhone1.errors?.required">The phone number is required</div>
                     <div class="text-danger col" *ngIf="(fval.userPhone1.touched||fval.userPhone1.dirty)  && fval.userPhone1.errors?.hasNumber">The phone number should be in digits/numbers</div>
                             <div class="text-danger col" *ngIf="(fval.userPhone1.touched||fval.userPhone1.dirty)  && fval.userPhone1.errors?.maxlength">The phone number should not exceed 10 digits</div>
                             <div class="text-danger col" *ngIf="(fval.userPhone1.touched||fval.userPhone1.dirty)  && fval.userPhone1.errors?.minlength">The phone number  should have atleast 10 digits</div>
                     </div>

      <div class="form-group text-primary">
        <label
          for="userPassword"
          [ngClass]="fval.userPassword.valid ? 'text-info' : ''"
          >PIN<i *ngIf="fval.userPassword.valid" class="material-icons"
            >check_circle</i
          ></label
        >

        <div class="input-group mb-0">
          <div class="input-group-prepend">
            <div class="input-group-text">
              <i
                class="fas fa-lock text-primary mx-auto"
                style="size: 50px;"
              ></i>
            </div>
          </div>
          <input
          [type]="fieldType ? 'text' : 'password'"
          id="userPassword"
          formControlName="userPassword"
            class="form-control"
            [ngClass]="{
              'is-invalid':
                (fval.userPassword.touched || fval.userPassword.dirty) &&
                fval.userPassword.errors
            }"
            placeholder="Enter your PIN"
            autocomplete="off"
          />
          <div class="input-group-append">
            <span class="input-group-text">
              <i
                class="fas"
                [ngClass]="{
                  'fa-eye-slash': !fieldType,
                  'fa-eye': fieldType
                }"
                (click)="toggleFieldType()"
              ></i>
            </span>
          </div>
        </div>
        <div
          class="text-danger col"
          *ngIf="
            (fval.userPassword.touched || fval.userPassword.dirty) &&
            fval.userPassword.errors?.required
          "
        >
          PIN is required!
        </div>
      </div>

      <div class="row d-flex flex-row">
        <div class="col-12 my-0 pt-2 pb-0">
          <div class="form-group">
            <button
              type="submit"
              class="btn btn-info col-12"
              [disabled]="!userForm.valid"
            >
              Login
            </button>

            <ngx-spinner
              class="bg-warning bg-info"
              size="small"
              type="ball-spin"
            >
              <h4 class="text-info">Loading...</h4>
            </ngx-spinner>
            <ngx-alerts></ngx-alerts>

            <div class="row">
              <div class="col" *ngIf="errored" class="text-danger">
                <!-- <i class="material-icons"></i> -->

                <ngx-alerts></ngx-alerts>
              </div>
            </div>
            <div class="row">
              <div class="col" *ngIf="posted" class="text-info">
                <!-- <i class="material-icons">check_circle</i> -->
                <ngx-alerts></ngx-alerts>
              </div>
            </div>
                </div>
        </div>
        <div class="col-12 d-flex flex-row justify-content-start mt-2 pt-0">
          <div class="form-group">
            Dont't have an account?<a class="text-info mr-0" routerLink="../register">
              Register &nbsp;<i class="fas fa-arrow-right"></i>
            </a>
          </div>
        </div>
        <div class="col-6 d-flex flex-row justify-content-start mt-0 pt-0">
          <div class="form-group" *ngIf="fval.userPhone1.valid">
            <a class="text-info mr-0" [routerLink]="['../changepassword', fval.userPhone1.value]">
              Forgot PIN?
            </a>
          </div>
        </div>
      </div>

    </form>
  </div>
</div>
</div>
<!--footer -->
<div class="d-flex justify-content-center col-xs-12 col-lg-12 mt-2 mx-auto">
  <div class="small text-center text-info">
   &copy; 2021 - ThunderBolt
  </div>
</div>
<!--/ footer -->

